export default __webpack_public_path__ + "static/media/multi-jet.54452365.png";